import { render, staticRenderFns } from "./wong-baker-faces.vue?vue&type=template&id=06e58410&"
import script from "./wong-baker-faces.vue?vue&type=script&lang=js&"
export * from "./wong-baker-faces.vue?vue&type=script&lang=js&"
import style0 from "./wong-baker-faces.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "wong-baker-faces.vue"
export default component.exports